import { render, staticRenderFns } from "./RegisterBuilding.vue?vue&type=template&id=5302bd28&"
import script from "./RegisterBuilding.vue?vue&type=script&lang=ts&"
export * from "./RegisterBuilding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports